// "My Database Vanished — Then a Zombie Lock Blocked Every Retry" — the 2026-07-04
// Supabase capacity outage + the acquire-time heartbeat lock-steal fix.
// Cold Compute / Neon kit. ~135s @ 30fps. Every claim grounded in the real incident:
// EAKC docs/2026-07-05-orphan-lock-recovery-architecture.md + src/lib/jobs/sync-lock.ts.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames (30fps); contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //         0:00–0:05  the DB vanished, code was fine
  notyou: { start: 150, duration: 540 }, //     0:05–0:23  522 / 57P03 / platform incident / 1GB Micro
  stuck: { start: 690, duration: 480 }, //      0:23–0:39  recovered (145ms) but sync stuck at 0%
  zombie: { start: 1170, duration: 540 }, //    0:39–0:57  the zombie lock — crashed job holds it forever
  deadzone: { start: 1710, duration: 660 }, //  0:57–1:19  the 8-to-120-min dead zone (centerpiece)
  fix: { start: 2370, duration: 600 }, //       1:19–1:39  acquire-time heartbeat steal → heals <8min
  landmine: { start: 2970, duration: 540 }, //  1:39–1:57  fail-open bug: stealing from a live sync; fail closed
  layers: { start: 3510, duration: 240 }, //    1:57–2:05  the five recovery layers
  outro: { start: 3750, duration: 300 }, //     2:05–2:15  the lesson
} as const;

export const TOTAL_DURATION = 4050; // 135s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
